import React from 'react';
import AgencyTemplate from '../components/AgencyTemplate';

const BPM = () => {
  const agencyData = {
    title: "Beijing Petroleum Machinery (BPM)",
    subtitle: "Petrochoice Agencies",
    description: "Beijing Petroleum Machinery Co., LTD (BPM) is founded in 1955, which is a modern enterprise that integrates R & D, design, manufacturing, sales and service into one. Under the leadership of CNPC Engineering Technology R&D Co., LTD, BPM continues to be one of the National high-tech enterprises and also a Provincial Technology Center. BPM specializes in Intelligent Hydraulic Pumping Units, replacing traditional sucker rod pumps to reduce production costs. BPM holds over 100 national patents and provides advanced drilling products, including top drive services, MWD & LWD tools, downhole motors, BOP control services, shock absorbers, and more.",
    image: "/assets/bpm-logo.png",
    imageAlt: "Beijing Petroleum Machinery (BPM) logo",
    features: [
      {
        title: "BPM Hydraulic Units",
        description: "High-efficiency intelligent hydraulic pumping units designed to replace traditional sucker rod pumps and reduce production costs.",
        icon: "bi bi-gear-fill",
        iconColor: "#0c61c0"
      },
      {
        title: "Drilling Products",
        description: "Top drives, MWD & LWD tools, downhole motors, BOP controls, shock absorbers, and more.",
        icon: "bi bi-tools",
        iconColor: "#28a745"
      }
    ]
  };

  return <AgencyTemplate {...agencyData} />;
};

export default BPM;



